/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-25 19:02:38
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 13:49:21
 * @Description: file content
 */
import Vue from 'vue/dist/vue.js';
import App from './app.vue';
import router from './router';
import pluginsAct from '@/plugins/act-plugin';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(pluginsAct);
Vue.mixin({
  computed: {
    imgHost() {
      return this.$config.imgHost
    },
    apiHost() {
      return this.$config.apiHost
    }
  }
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')